<app-header [sidenav]="sidenav"></app-header>
<mat-sidenav-container class="app-container" autosize>
    <mat-sidenav #sidenav mode="push">
        <mat-nav-list>
            <mat-list-item [routerLink]="['/home']" routerLinkActive="active">
                <mat-icon matListItemIcon>home</mat-icon><a matListItemTitle>Home</a>
            </mat-list-item>
            <mat-list-item [routerLink]="['/audit-log']" routerLinkActive="active">
                <mat-icon matListItemIcon>list_alt</mat-icon><a matListItemTitle>Audit Log</a>
            </mat-list-item>
            <mat-list-item *ngIf="hasUserAccess" [routerLink]="['/access-request']">
                <mat-icon matListItemIcon>account_box</mat-icon><a matListItemTitle>Drive Access</a>
            </mat-list-item>
            <mat-list-item (click)="goToHelp()">
                <mat-icon matListItemIcon>live_help</mat-icon><a matListItemTitle>Help</a>
            </mat-list-item>
            
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
        <app-loader></app-loader>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
<app-footer></app-footer>